import { Routes } from '@angular/router';
import { Login } from './pages/auth/login/login';
import { Register } from './pages/auth/register/register';
import { RegisterMerchant } from './pages/auth/register-merchant/register-merchant';
import { ResetPassword } from './pages/auth/reset-password/reset-password';
import { Address } from './pages/dashboard/address/address';
import { AppDashboardLayout } from './layout/app-dashboard-layout/app-dashboard-layout';
import { AppLayout } from './layout/app-layout/app-layout';
import { Home } from './pages/home/home';
import { ContactUs } from './pages/support-privacy/contact-us/contact-us';
import { ForgotPassword } from './pages/auth/forgot-password/forgot-password';
import { MerchantRegisterStep } from './pages/auth/merchant-register-step/merchant-register-step';
import { VerifyEmail } from './pages/auth/verify-email/verify-email';
import { QuickLogin } from './pages/auth/quick-login/quick-login';
import { AdminPreview } from './pages/auth/admin-preview/admin-preview';
import { authGuard, guestGuard, loggedInGuard } from './shared/guard/auth.guard';
import { AgeVerification } from './pages/auth/age-verification/age-verification';
import { AgeVerificationCallback } from './pages/auth/age-verification-callback/age-verification-callback';
import { Setting } from './pages/dashboard/setting/setting';
import { Preferences } from './pages/dashboard/preferences/preferences';
import { PreferenceOptions } from './pages/dashboard/preferences/preference-options/preference-options';
import { Chat } from './pages/dashboard/chat/chat';
import { Profile } from './pages/dashboard/profile/profile';
import { Events } from './pages/events/events';
import { EventDetails } from './pages/event-details/event-details';
import { Posts } from './pages/posts/posts';
import { PostDetails } from './pages/post-details/post-details';
import { Blog } from './pages/blog/blog';
import { CreateBlog } from './pages/create-blog/create-blog';
import { BlogDetails } from './pages/blog-details/blog-details';
import { Favorites } from './pages/dashboard/favorites/favorites';
import { BlockedUser } from './pages/dashboard/blocked-user/blocked-user';
import { All } from './pages/all/all';
import { DashboardLegal } from './pages/dashboard/legal/legal';
import { AgeVerificationPolicy } from './pages/legal/age-verification-policy/age-verification-policy';
import { CommunityGuidelines } from './pages/legal/community-guidelines/community-guidelines';
import { CookiePolicy } from './pages/legal/cookie-policy/cookie-policy';
import { PrivacyPolicy } from './pages/legal/privacy-policy/privacy-policy';
import { TermsOfService } from './pages/legal/terms-of-service/terms-of-service';

export const routes: Routes = [
    {
    path:'',
    component:AppLayout,
    children:[
        {
            path: '',
            component: Home,
            canActivate: [guestGuard],
        },
        {
            path: 'contact-us',
            component: ContactUs,
        },
        {
            path: 'profile/:userName/:type',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Profiles' },
            component: Profile,
        },
        {
            path: 'events',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Events' },
            component: Events,
        },
        {
            path: 'all',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'All' },
            component: All,
        },
        {
            path: 'event/:id',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Events', adminPreviewType: 'EVENT' },
            component: EventDetails,
        },
        {
            path: 'posts',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Posts' },
            component: Posts,
        },
        {
            path: 'post/:id',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Posts', adminPreviewType: 'POST' },
            component: PostDetails,
        },
        {
            path: 'blogs',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Blogs' },
            component: Blog,
        },
        {
            path: 'blog/create',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Blogs' },
            component: CreateBlog,
        },
        {
            path: 'blog/:id',
            canActivate: [authGuard],
            data: { loginPromptLabel: 'Blogs', adminPreviewType: 'BLOG' },
            component: BlogDetails,
        },
        {
            path: 'legal/terms',
            component: TermsOfService,
        },
        {
            path: 'legal/privacy-policy',
            component: PrivacyPolicy,
        },
        {
            path: 'legal/cookie-policy',
            component: CookiePolicy,
        },
        {
            path: 'legal/community-guidelines',
            component: CommunityGuidelines,
        },
        {
            path: 'legal/age-verification',
            component: AgeVerificationPolicy,
        },
      ]
    },
    {
    path:'dashboard',
    component:AppDashboardLayout,
    canActivate: [authGuard],
    data: { loginPromptLabel: 'Dashboard' },
    children:[
        {
            path: 'address',
            component: Address,
            pathMatch: 'full',
        },
        {
            path: 'chat',
            component: Chat,
            pathMatch: 'full',
        },
        {
            path: 'setting',
            component: Setting,
            pathMatch: 'full',
        },
        {
            path: 'preferences',
            component: Preferences,
            pathMatch: 'full',
        },
        {
            path: 'preferences/:category',
            component: PreferenceOptions,
            pathMatch: 'full',
        },
        {
            path: 'favorites',
            component: Favorites,
            pathMatch: 'full',
        },
        {
            path: 'blocked-user',
            component: BlockedUser,
            pathMatch: 'full',
        },
        {
            path: 'legal',
            component: DashboardLegal,
            pathMatch: 'full',
        },
      ]
    },
    {
        path: "login",
        component: Login,
        canActivate: [guestGuard]
    },
    {
        path: "register",
        component: Register,
        canActivate: [guestGuard]
    },
    {
        path: "register-merchant",
        component: RegisterMerchant,
        canActivate: [guestGuard]
    },
    {
        path: "reset-password",
        component: ResetPassword,
        canActivate: [guestGuard]
    },
    {
        path: "forgot-password",
        component: ForgotPassword,
        canActivate: [guestGuard]
    },
    {
        path: "merchant-registration-step",
        component: MerchantRegisterStep,
        canActivate: [guestGuard]
    },
    {
        path: "verify-email",
        component: VerifyEmail,
        canActivate: [guestGuard]
    },
    // Admin panel "Quick Login" landing page. No guard on purpose: it must
    // work even when this browser is already signed in as someone else.
    {
        path: "quick-login",
        component: QuickLogin,
    },
    // Admin panel "open on site" landing page. Opens ONE post/blog/event
    // without a login (see AdminPreviewService). No guard on purpose.
    {
        path: "admin-preview",
        component: AdminPreview,
    },
    // VerifyMy age verification (18+). Logged-in only, but deliberately NOT
    // behind authGuard, which redirects unverified users here.
    {
        path: "age-verification",
        component: AgeVerification,
        canActivate: [loggedInGuard]
    },
    {
        // Must match VERIFYMY_REDIRECT_URL on the backend and be registered
        // as an allowed redirect in the VerifyMy dashboard.
        path: "age-verification/callback",
        component: AgeVerificationCallback,
        canActivate: [loggedInGuard]
    }
];
